export const AccountTypes = {
    SHOW_ACCOUNT: "SHOW_ACCOUNT",
    ADD_ACCOUNT: "ADD_ACCOUNT",
    UPDATE_ACCOUNT: "UPDATE_ACCOUNT",
    DELETE_ACCOUNT: "DELETE_ACCOUNT"
}